export const validatorPositive = (value) => {
  if (value >= 0) {
    return true;
  }
  return false;
};

export const validatorPassword = (password) => {
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/;
  const validPassword = regExp.test(password);
  return validPassword;
};

export const validatorCreditCard = (creditnum) => {
  const cRegExp = /^(?:3[47][0-9]{13})$/;
  const validCreditCard = cRegExp.test(creditnum);
  return validCreditCard;
};

export const validatorPhoneNumber = (phone) => {
  const cRegExp = /^09[0|1|2|3|9][0-9]{8}$/;
  const validPhoneNumber = cRegExp.test(phone);
  return validPhoneNumber;
};

export const validatorIBANNum = (iban) => {
  const cRegExp = /^(?:IR)(?=.{24}$)[0-9]*$/;
  const validIban = cRegExp.test(iban);
  return validIban;
};

export const validatorNationalCode = (code) => {
  const cRegExp = /^[0-9]{10}$/;
  const validNationalCode = cRegExp.test(code);
  return validNationalCode;
};

export const validatorShabaNumber = (code) => {
  const cRegExp = /^IR\d{24}$/;
  const validShabaNumber = cRegExp.test(code);
  return validShabaNumber;
};

export const validatorUserName = (code) => {
  const cRegExp = /^[a-zA-Z0-9-]{3,25}$/;
  const validUserName = cRegExp.test(code);
  return validUserName;
};

export const validatorStoreId = (code) => {
  const cRegExp = /^[a-zA-Z0-9-]{3,25}$/;
  const validStoreId = cRegExp.test(code);
  return validStoreId;
};

export const validatorUrlValidator = (val) => {
  if (val === undefined || val === null || val.length === 0) {
    return true;
  }
  const re =
    /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
  return re.test(val);
};
